export default function useNotificationPermissionEnabled() {
  return null;
}
